<template>
<div class="box">
   <div class="carouselBox">
      <transition-group tag="ul" enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutUp">
        <li v-show="idx == isCurrent" v-for="(item, idx) in messageList" :key="idx" :class="['carousel']">
         <span class="good">{{item}}</span>
        </li>
      </transition-group>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      messageList: [
        '电风********啦',
        '你********包',
        '十二********就',
      ],
      isCurrent: 0,
      bookName: 'vue权威指南'
    }
  },
  methods: {
    autoPlay () {
      let length = this.messageList.length
      if (this.isCurrent >= length) {
        this.isCurrent = 0
        this.autoPlay()
      } else {
        setTimeout(() => {
          this.isCurrent++
          this.autoPlay()
        }, 3000)
      }
    },
    // Object.defineProperty 数据双向绑定
    bindData () {
      var Book = {}
      var name = '';
      Object.defineProperty(Book, 'name', {
        set: function (value) {
          name = value;
          console.log('你取了一个书名叫做' + value);
        },
        get: function () {
          return '《' + name + '》'
        }
      })

      Book.name = 'CSS世界';  // 你取了一个书名叫做vue权威指南
      console.log(Book.name);  // 《vue权威指南》
      console.log(Book);  // 《vue权威指南》

    }
  },
  mounted () {
    this.autoPlay();
    this.bindData()
  }
}
</script>

<style lang="less" scoped>
.box {
  width: 300px;
  height: 40px;
  border: 1px dashed rgb(211, 23, 54);
  margin: 0 auto;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.carouselBox {
  width: 260px;
  height: 30px;
  position: relative;
}
.carousel {
  width: 220px;
  font-size: 14px;
  border-radius: 30px;
  padding-left: 30px;
  position: absolute;
  color: #fff;
  display: -webkit-box;
  -webkit-box-pack: left;
  -webkit-box-align: center;
}
.good {
  color: rgb(182, 8, 8);
  line-height: 30px;
  margin-left: 8px;
}
</style>
<style>
.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 0.5s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    /* display: none; */
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }

  to {
    /* display: block; */
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeOutUp {
  from {
    opacity: 1;
    /* display: block; */
  }

  to {
    opacity: 0;
    /* display: none; */
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
}
.fadeInUp {
  -webkit-animation-name: fadeInUp;
  animation-name: fadeInUp;
}
.fadeOutUp {
  -webkit-animation-name: fadeOutUp;
  animation-name: fadeOutUp;
}
</style>
